"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opengraphdata = void 0;
/**
 * load open graph data from page header
 */
// @ts-ignore
exports.opengraphdata = window === null || window === void 0 ? void 0 : window.__OPENGRAPH_DATA__;
